import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { styled, keyframes } from '@mui/system';

const fadeIn = keyframes`
  0% { opacity: 0; transform: scale(0.9); }
  100% { opacity: 1; transform: scale(1); }
`;

const IconWrapper = styled(Box)(({ theme }) => ({
  fontSize: '8rem',
  color: theme.palette.error.main,
  marginBottom: theme.spacing(2),
}));

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    try {
      const userData = JSON.parse(localStorage.getItem('userInfo'));
      const permissions = userData?.profile?.permissions || {};

      // Records
      if (permissions?.campaign_leads_page_access) {
        navigate('/r/records/v1');
        return;
      }

      // Homepage
      if (permissions?.homepage_access) {
        navigate('/r/management/manageCampaign');
        return;
      }

      // ✅ Whatsapp Template Dashboard
      if (permissions?.can_view_template_dashboard_new) {
        navigate('/r/whatsapp/template-list');
        return;
      }
      if (userPermissions?.can_view_concept_builder) {
        navigate('/r/student/concept-builder');
        return;
      }

      // ✅ Intervene
      if (permissions?.can_view_intervene_new) {
        navigate('/r/intervene-dashboard');
        return;
      }

      navigate('/r/student/concept-builder');
    } catch (error) {
      // 🔹 USER NOT LOGGED IN
      navigate('/r/login');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '80vh',
        width: '100%',
        backgroundColor: 'background.paper',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          textAlign: 'center',
          animation: `${fadeIn} 1s ease-out`,
        }}
      >
        <IconWrapper>
          <ErrorOutlineIcon sx={{ fontSize: { xs: '6rem', md: '8rem' } }} />
        </IconWrapper>

        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '4rem', md: '6rem' },
            fontWeight: 'bold',
            mb: 2,
          }}
        >
          404
        </Typography>

        <Typography variant="h5" sx={{ mb: 2 }}>
          Oops! Page Not Found
        </Typography>

        <Typography variant="body1" sx={{ mb: 4 }}>
          No match for <code style={{ color: '#d32f2f' }}>{location.pathname}</code>
        </Typography>

        <Button
          variant="contained"
          size="large"
          startIcon={<HomeIcon />}
          onClick={handleGoHome}
          sx={{
            borderRadius: 5,
            textTransform: 'none',
            px: 5,
            py: 1.5,
          }}
        >
          Go to Home
        </Button>
      </Container>
    </Box>
  );
};

export default ErrorPage;
